import React from 'react';

import style from './LoadingPlaceholders.module.scss';

const LoadingPlaceholders = ({ rows = 5, rowSpacing = 10, rowHeight = 18, loading, children }) =>
  loading
    ? Array.from({ length: rows }, (_, i) => (
        <div key={i.toString()}>
          <div
            className={style.placeholder}
            style={{ marginBottom: `${rowSpacing}px`, height: `${rowHeight}px` }}
          />
        </div>
      ))
    : children;

export default LoadingPlaceholders;
